import Navbar from "../components/Nav/Nav";
import NavHook from "../components/Nav/NavHook";
import RefreshedFooter from "../components/RefreshedFooter/RefreshedFooter";

export default function Policy({ footer, navigation, locale }) {
  if (locale === "es") {
    const pdfUrl = "https://static.horsnormes.co/static/legal/CGV-spain.pdf";
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Navbar links={navigation.links} />
        <iframe
          src={pdfUrl}
          style={{ width: "100%", height: "100vh" }}
          title="Policy PDF"
        />
        <RefreshedFooter links={footer.links} />
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Navbar links={navigation.links} />
      <main
        style={{
          maxWidth: "860px",
          margin: "0 auto",
          padding: "40px 20px",
          color: "#222",
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
          lineHeight: 1.6,
          fontSize: "16px",
        }}
      >
        <h1 style={{ textAlign: "center", marginBottom: "32px" }}>
          POLITIQUE DE CONFIDENTIALITE
        </h1>

        <p>
          Chez <strong>BENE BONO</strong>, la protection de vos données
          personnelles est une priorité.
        </p>
        <p>
          Lors de votre utilisation du site benebono.fr (ci-après le «&nbsp;
          <strong>Site</strong>&nbsp;») nous sommes amenés à recueillir des
          données à caractère personnel vous concernant.
        </p>
        <p>
          Le but de cette politique est de vous informer sur les modalités selon
          lesquelles nous traitons ces données en conformité avec le Règlement
          (UE) 2016/679 du 27 avril 2016 relatif à la protection des personnes
          physiques à l&apos;égard du traitement des données à caractère
          personnel et à la libre circulation de ces données (ci-après le
          «&nbsp;<strong>RGPD</strong>&nbsp;»).
        </p>

        <h2>1. Qui est le responsable de traitement ?</h2>
        <p>
          Le responsable de traitement est la société <strong>Bene Bono</strong>
          , société par actions simplifiée à capital variable, immatriculée au
          RCS de Paris sous le n° 882 940 539 et dont le siège social est situé
          au 1 rue de Stockholm, 75008 PARIS (ci-après «&nbsp;
          <strong>Nous</strong>&nbsp;»).
        </p>

        <h2>2. Quelles données collectons-nous ?</h2>
        <p>
          Une donnée à caractère personnel est une donnée qui permet
          d&apos;identifier un individu directement ou par recoupement avec
          d&apos;autres données.
        </p>
        <p>
          Nous collectons des données qui relèvent des catégories suivantes :
        </p>
        <ul>
          <li>
            <strong>Des données d&apos;identification</strong> (nom, prénom,
            adresse email, adresse de facturation, adresse de livraison,
            complément d&apos;adresse) ;
          </li>
          <li>
            <strong>Des données relatives à vos commandes</strong> ;
          </li>
          <li>
            <strong>Des données de connexion</strong> (par exemple adresse IP,
            système d&apos;exploitation, logs, mot de passe) ;
          </li>
          <li>
            <strong>Des données relatives à vos cartes bancaires</strong>.
          </li>
        </ul>
        <p>
          Les données obligatoires sont indiquées lorsque vous nous fournissez
          vos données. Elles sont signalées par un astérisque et sont
          nécessaires pour vous fournir nos services.
        </p>

        <h2>
          3. Sur quelles bases légales, pour quelles finalités et pendant
          combien de temps conservons nous vos données personnelles ?
        </h2>

        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "16px",
              marginBottom: "16px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f5f5f5" }}>
                <th style={tableHeaderStyle}>Finalités</th>
                <th style={tableHeaderStyle}>Bases légales</th>
                <th style={tableHeaderStyle}>Durées de conservation</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={tableCellStyle}>
                  Vous permettre de souscrire à notre abonnement et de commander
                  votre panier
                </td>
                <td style={tableCellStyle}>
                  Exécution de mesures précontractuelles prises à votre demande
                  et/ou exécution des CGV que vous avez acceptées
                </td>
                <td style={tableCellStyle}>
                  <p>
                    Lorsque vous vous êtes créé un compte : vos données sont
                    conservées pour toute la durée de votre compte et augmentée
                    d&apos;un délai de 3 ans à compter de la suppression de
                    votre compte, à des fins de prospection.
                  </p>
                  <p>
                    En cas de compte inactif pendant 2 ans, vos données
                    personnelles seront supprimées.
                  </p>
                  <p>
                    En outre, vos données peuvent être archivées à des fins
                    probatoires pendant une durée de 5 ans.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={tableCellStyle}>
                  Vous permettre de créer un compte, d&apos;y accéder, de gérer
                  vos commandes et modifier vos données personnelles depuis ce
                  compte
                </td>
                <td style={tableCellStyle}>
                  Exécution des CGV que vous avez acceptées
                </td>
                <td style={tableCellStyle}>
                  <p>
                    Vos données sont conservées pour toute la durée de votre
                    compte et augmentée d&apos;un délai de 3 ans à compter de la
                    suppression de votre compte, à des fins de prospection.
                  </p>
                  <p>
                    En cas de compte inactif pendant 2 ans, vos données
                    personnelles seront supprimées.
                  </p>
                  <p>
                    En outre, vos données peuvent être archivées à des fins
                    probatoires pendant une durée de 5 ans.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={tableCellStyle}>
                  Exécuter votre commande, effectuer les opérations relatives à
                  la gestion des clients concernant les contrats, commandes,
                  livraisons, factures, programmes de fidélité et suivi de la
                  relation avec les clients
                </td>
                <td style={tableCellStyle}>
                  Exécution des CGV que vous avez acceptées
                </td>
                <td style={tableCellStyle}>
                  <p>
                    Les données personnelles sont conservées pendant toute la
                    durée de la relation contractuelle et augmentée d&apos;un
                    délai de 3 ans à compter de la fin de cette dernière, à des
                    fins de prospection.
                  </p>
                  <p>
                    En outre, vos données (à l&apos;exception de vos coordonnées
                    bancaires) sont archivées à des fins probatoires pendant une
                    durée de 5 ans.
                  </p>
                  <p>
                    Concernant les données relatives à votre carte bancaire,
                    elles sont conservées par notre prestataire de service de
                    paiement pendant la durée de votre abonnement.
                  </p>
                  <p>
                    Les données relatives au cryptogramme visuel ou CVV2,
                    inscrites sur votre carte bancaire, sont stockées sur les
                    serveurs de notre prestataire de service de paiement avec
                    votre consentement.
                  </p>
                  <p>
                    Les données relatives à vos cartes bancaires pourront être
                    conservées, pour une finalité de preuve en cas
                    d&apos;éventuelle contestation de la transaction, en
                    archives intermédiaires pendant une durée de treize (13)
                    mois suivant la date de débit. Ce délai peut être étendu à
                    quinze (15) mois afin de prendre en compte la possibilité
                    d&apos;utilisation des cartes de paiement à débit différé.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={tableCellStyle}>
                  Adresser des newsletters lorsque vous avez un compte et avez
                  déjà passé chez nous
                </td>
                <td style={tableCellStyle}>
                  Notre intérêt légitime à développer et promouvoir notre
                  activité
                </td>
                <td style={tableCellStyle}>
                  Vos données sont conservées pendant 3 ans à compter de la
                  suppression de votre compte sauf si vous vous êtes opposé à
                  l&apos;envoi de ces communications commerciales.
                </td>
              </tr>
              <tr>
                <td style={tableCellStyle}>
                  Adresser des newsletters lorsque vous n&apos;avez pas de
                  compte ou si vous n&apos;avez jamais encore passé commande via
                  votre compte
                </td>
                <td style={tableCellStyle}>Votre consentement</td>
                <td style={tableCellStyle}>
                  Vos données sont conservées pendant 3 ans à compter de votre
                  dernier contact avec Nous sauf si vous vous êtes opposé à
                  l&apos;envoi de ces communications commerciales.
                </td>
              </tr>
              <tr>
                <td style={tableCellStyle}>
                  Répondre à vos demandes d&apos;information
                </td>
                <td style={tableCellStyle}>
                  Notre intérêt légitime à répondre à vos demandes
                </td>
                <td style={tableCellStyle}>
                  Les données sont conservées pendant le temps nécessaire au
                  traitement de votre demande d&apos;information et supprimées
                  une fois la demande d&apos;information traitée.
                </td>
              </tr>
              <tr>
                <td style={tableCellStyle}>
                  Se conformer aux obligations légales applicables à notre
                  activité
                </td>
                <td style={tableCellStyle}>
                  Se conformer à nos obligations légales et règlementaires
                </td>
                <td style={tableCellStyle}>
                  <p>
                    Pour les factures : les factures sont archivées pendant une
                    durée de 10 ans.
                  </p>
                  <p>
                    Les données relatives à vos transactions (à l&apos;exception
                    des données bancaires) sont conservées pendant 5 ans à des
                    fins probatoires.
                  </p>
                </td>
              </tr>
              <tr>
                <td style={tableCellStyle}>
                  Gérer les demandes d&apos;exercice de droits
                </td>
                <td style={tableCellStyle}>
                  Se conformer à nos obligations légales et règlementaires
                </td>
                <td style={tableCellStyle}>
                  <p>
                    Si nous vous demandons un justificatif d&apos;identité :
                    nous le conservons seulement pendant le temps nécessaire à
                    la vérification d&apos;identité. Une fois la vérification
                    effectuée, le justificatif est supprimé.
                  </p>
                  <p>
                    Si vous exercez votre droit d&apos;opposition à exercer de
                    la prospection : nous conservons cette information pendant 3
                    ans.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2>4. Quels cookies utilisons-nous ?</h2>
        <p>
          Pour en savoir plus sur la gestion des cookies nous vous invitons à
          consulter notre <strong>Politique cookies</strong>.
        </p>

        <h2>5. Qui sont les destinataires de vos données ?</h2>
        <p>Auront accès à vos données à caractère personnel :</p>
        <ol style={{ listStyleType: "lower-roman" }}>
          <li>
            Le personnel de notre société ; nos livreurs ; les points de retrait
            ;
          </li>
          <li>
            Nos sous-traitants : prestataire d&apos;hébergement, prestataire de
            livraisons, prestataire de préparation des paniers, prestataire
            d&apos;envoi de newsletters, prestataire de service de paiement,
            outil CRM, prestataire de gestion d&apos;emails ;
          </li>
          <li>Nos partenaires en points relais ;</li>
          <li>
            Le cas échéant : les organismes publics et privés, exclusivement
            pour répondre à nos obligations légales.
          </li>
        </ol>

        <h2>
          6. Vos données sont-elles susceptibles d&apos;être transférées hors de
          l&apos;Union européenne ?
        </h2>
        <p>
          Vos données sont conservées et stockées pendant toute la durée des
          traitements sur les serveurs de la société Amazon Web Service
          localisés à Paris. Les adresses emails et mots de passe ainsi que les
          autres données de commande antérieures au 15/1/2022 sont stockées sur
          les serveurs de la société Shopify, situés au Canada.
        </p>
        <p>
          Dans le cadre des outils que nous utilisons (voir article sur les
          destinataires concernant nos sous-traitants), vos données sont
          susceptibles de faire l&apos;objet de transferts hors de l&apos;Union
          européenne. Le transfert de vos données dans ce cadre est sécurisé au
          moyen des outils suivants :
        </p>
        <ul>
          <li>
            soit les données sont transférées dans un pays ayant fait
            l&apos;objet d&apos;une décision d&apos;adéquation de la Commission
            européenne : dans ce cas, ce pays assure un niveau de protection
            jugé comme suffisant et adéquat aux dispositions du RGPD ;
          </li>
          <li>
            soit les données sont transférées dans un pays dont le niveau de
            protection des données n&apos;a pas été reconnu comme adéquat au
            RGPD : dans ce cas ces transferts sont fondés sur des mécanismes de
            protection adaptés à chaque prestataire tels que la conclusion de
            clauses contractuelles types approuvées par la Commission
            Européenne, l&apos;application de règles d&apos;entreprises
            contraignantes ou en vertu d&apos;un mécanisme de certification
            approuvé ;
          </li>
          <li>
            soit nous avons recours aux garanties appropriées prévues par la
            réglementation applicable.
          </li>
        </ul>

        <h2>7. Quels sont vos droits sur vos données ?</h2>
        <p>
          Vous disposez des droits suivants s&apos;agissant de vos données
          personnelles :
        </p>
        <ul>
          <li>
            <strong>Droit à l&apos;information</strong> : c&apos;est justement
            la raison pour laquelle nous avons rédigé la présente politique. Ce
            droit est prévu par les articles 13 et 14 du RGPD.
          </li>
          <li>
            <strong>Droit d&apos;accès</strong> : vous avez le droit
            d&apos;accéder à tout moment à l&apos;ensemble de vos données
            personnelles, en vertu de l&apos;article 15 du RGPD.
          </li>
          <li>
            <strong>Droit de rectification</strong> : vous avez le droit de
            rectifier à tout moment vos données personnelles inexactes,
            incomplètes ou obsolètes conformément à l&apos;article 16 du RGPD.
          </li>
          <li>
            <strong>Droit à la limitation</strong> : vous avez le droit
            d&apos;obtenir la limitation du traitement de vos données
            personnelles dans certains cas définis à l&apos;article 18 du RGPD.
          </li>
          <li>
            <strong>Droit à l&apos;effacement</strong> : vous avez le droit
            d&apos;exiger que vos données personnelles soient effacées, et
            d&apos;en interdire toute collecte future pour les motifs énoncés à
            l&apos;article 17 du RGPD.
          </li>
          <li>
            <strong>
              Droit d&apos;introduire une réclamation auprès d&apos;une autorité
              de contrôle compétente
            </strong>{" "}
            (en France, la CNIL), si vous considérez que le traitement de vos
            données personnelles constitue une violation des textes applicables
            (article 77 du RGPD).
          </li>
          <li>
            <strong>
              Droit de définir des directives relatives à la conservation, à
              l&apos;effacement et à la communication de vos données
              personnelles après votre mort
            </strong>
            , conformément à l&apos;article 40-1 de la loi informatique et
            libertés.
          </li>
          <li>
            <strong>Droit de retirer votre consentement à tout moment</strong> :
            pour les finalités fondées sur le consentement, l&apos;article 7 du
            RGPD dispose que vous pouvez retirer votre consentement à tout
            moment. Ce retrait ne remettra pas en cause la légalité du
            traitement effectué avant le retrait.
          </li>
          <li>
            <strong>Droit à la portabilité</strong> : selon certaines conditions
            précisées à l&apos;article 20 du RGPD, vous avez le droit de
            recevoir les données personnelles que vous nous avez fournies dans
            un format standard lisible par machine et d&apos;exiger leur
            transfert au destinataire de votre choix.
          </li>
          <li>
            <strong>Droit d&apos;opposition</strong> : en vertu de
            l&apos;article 21 du RGPD, vous avez le droit de vous opposer au
            traitement de vos données personnelles. Notez toutefois que nous
            pourrons maintenir leur traitement malgré cette opposition, pour des
            motifs légitimes ou la défense de droits en justice.
          </li>
        </ul>
        <p>
          Vous pouvez exercer ces droits en nous écrivant aux coordonnées
          ci-dessous. Nous pourrons vous demander à cette occasion de nous
          fournir des informations ou documents complémentaires pour justifier
          votre identité.
        </p>

        <h2>8. Point de contact en matière de données personnelles</h2>
        <p>
          Email de contact :{" "}
          <a href="mailto:miam@benebono.fr">miam@benebono.fr</a>
        </p>
        <p>
          Adresse de contact :{" "}
          <strong>Bene Bono - 131 Avenue de Choisy, 75013 PARIS</strong>
        </p>

        <h2>9. Modifications</h2>
        <p>
          Nous pouvons modifier à tout moment la présente politique, afin
          notamment de nous conformer à toutes évolutions réglementaires,
          jurisprudentielles, éditoriales ou techniques. Ces modifications
          s&apos;appliqueront à la date d&apos;entrée en vigueur de la version
          modifiée. Vous êtes donc invité à consulter régulièrement la dernière
          version de cette politique. Néanmoins, nous vous tiendrons informé(e)
          de toute modification significative de la présente politique de
          confidentialité.
        </p>
        <p>
          <strong>Entrée en vigueur :</strong> 24/10/2025
        </p>
      </main>

      <RefreshedFooter links={footer.links} />
    </div>
  );
}

const tableHeaderStyle = {
  border: "1px solid #ddd",
  padding: "12px",
  textAlign: "left",
  fontWeight: "bold",
};

const tableCellStyle = {
  border: "1px solid #ddd",
  padding: "12px",
  verticalAlign: "top",
};

export async function getServerSideProps({ query, locale }) {
  const mainNav = await NavHook(locale, "main");
  const navigation = {
    links: mainNav,
  };

  const footerNav = await NavHook(locale, "footer");
  const footer = {
    links: footerNav,
  };

  return {
    props: {
      footer,
      navigation,
      locale,
    },
  };
}
